import { Landmark, QrCode, Upload, ImageIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fileUrl } from "@/lib/api";

export const DonationPayment = ({ settings, method, setMethod, showUpload, setShowUpload, proof, setProof, children }) => {
  const hasBank = !!settings?.bank_account;
  const hasQris = !!settings?.qris_path;

  return (
    <div className="rounded-3xl emerald-bg pattern-overlay text-white p-6 sm:p-8 flex flex-col gap-5">
      <div>
        <p className="text-xs uppercase tracking-widest text-[#80b996] font-semibold">Metode Pembayaran</p>
        <div className="mt-3 grid grid-cols-2 gap-3">
          <button type="button" onClick={() => { setMethod("transfer"); setShowUpload(false); }} data-testid="donation-method-transfer"
            className={`rounded-2xl border p-4 text-left transition-colors ${method === "transfer" ? "bg-[#d4af37] text-emerald-950 border-transparent" : "border-white/15 hover:bg-white/5"}`}>
            <Landmark size={18} /><p className="mt-2 text-sm font-semibold">Transfer Bank</p>
          </button>
          <button type="button" onClick={() => { setMethod("qris"); setShowUpload(false); }} data-testid="donation-method-qris"
            className={`rounded-2xl border p-4 text-left transition-colors ${method === "qris" ? "bg-[#d4af37] text-emerald-950 border-transparent" : "border-white/15 hover:bg-white/5"}`}>
            <QrCode size={18} /><p className="mt-2 text-sm font-semibold">QRIS</p>
          </button>
        </div>
      </div>

      {method === "transfer" && (
        <div className="rounded-2xl bg-black/20 p-5" data-testid="donation-bank-info">
          {hasBank ? (
            <>
              <p className="text-xs text-emerald-300">{settings.bank_name}</p>
              <p className="font-mono text-2xl font-bold tracking-wider mt-1 gold-text">{settings.bank_account}</p>
              <p className="text-sm text-emerald-100 mt-1">a.n. {settings.bank_holder}</p>
            </>
          ) : (
            <p className="text-sm text-emerald-200">Informasi rekening belum diatur oleh pengurus.</p>
          )}
        </div>
      )}
      {method === "qris" && (
        <div className="rounded-2xl bg-black/20 p-5 flex flex-col items-center" data-testid="donation-qris-info">
          {hasQris ? (
            <img src={fileUrl(settings.qris_path)} alt="QRIS Masjid Al-Iman" className="w-56 h-56 object-contain rounded-xl bg-white p-2" data-testid="donation-qris-image" />
          ) : (
            <p className="text-sm text-emerald-200 flex items-center gap-2"><ImageIcon size={16} /> Gambar QRIS belum diunggah oleh pengurus.</p>
          )}
          <p className="text-xs text-emerald-300 mt-3">Scan dengan aplikasi bank / e-wallet apa pun</p>
        </div>
      )}

      {method && !showUpload && (
        <Button type="button" onClick={() => setShowUpload(true)} className="rounded-full h-11 bg-white text-emerald-950 hover:bg-emerald-50" data-testid="donation-paid-btn">
          Saya Sudah Transfer
        </Button>
      )}
      {showUpload && (
        <div className="space-y-3" data-testid="donation-upload-area">
          <label className="block rounded-2xl border-2 border-dashed border-white/25 p-5 text-center cursor-pointer hover:bg-white/5 transition-colors">
            <Upload size={20} className="mx-auto text-[#d4af37]" />
            <p className="mt-2 text-sm font-medium">{proof ? proof.name : "Unggah foto bukti transfer"}</p>
            <p className="text-xs text-emerald-300 mt-1">JPG / PNG, maks. 5 MB</p>
            <input type="file" accept="image/*" className="hidden" onChange={(e) => setProof(e.target.files?.[0] || null)} data-testid="donation-proof-input" />
          </label>
          {proof && <img src={URL.createObjectURL(proof)} alt="Preview bukti" className="max-h-40 rounded-xl mx-auto" data-testid="donation-proof-preview" />}
          {children}
        </div>
      )}
      {!method && <p className="text-sm text-emerald-200/80">Pilih metode pembayaran untuk melihat rekening atau QRIS.</p>}
    </div>
  );
};
